import { render, staticRenderFns } from "./JdbNotice.vue?vue&type=template&id=62107890&scoped=true&"
import script from "./JdbNotice.vue?vue&type=script&lang=js&"
export * from "./JdbNotice.vue?vue&type=script&lang=js&"
import style0 from "./JdbNotice.vue?vue&type=style&index=0&id=62107890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62107890",
  null
  
)

export default component.exports